// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Identity card  basestyles */
@media (forced-colors: active) {
  .bolt-identity-card-callout {
    border: 1px solid WindowText;
  }
}

.bolt-identity-card {
  max-height: 1200px;
  width: 360px;
}
@media screen and (max-width: 599px) {
  .bolt-identity-card {
    max-width: 360px;
    width: 100%;
  }
}
.bolt-identity-card.loading {
  height: 472px;
}

.word-wrap {
  word-break: break-all;
}

.bolt-identity-card-content {
  padding-bottom: 12px;
}

.bolt-button.bolt-identity-card-go-back-wrapper {
  background-color: rgba(0, 120, 212, 1);
  background-color: var(--communication-background,rgba(0, 120, 212, 1));
  justify-content: flex-start;
  flex-shrink: 1;
  overflow: hidden;
}

.bolt-identity-card-hr {
  margin-bottom: 12px;
  margin-top: 12px;
  border-width: 0;
  height: 1px;
  background-color: rgba( 234, 234, 234 ,  1 );
  background-color: rgba( var(--palette-neutral-8,234, 234, 234) ,  1 );
}

.bolt-button.bolt-identity-card-persona-list-element {
  font-weight: inherit;
  flex-shrink: 1;
  flex-grow: 1;
  justify-content: flex-start;
  overflow: hidden;
}

.bolt-identity-card-persona-list-row {
  padding: 3px;
}

.bolt-identity-card-name {
  padding: 0 12px;
}

.bolt-identity-card-persona-main {
  margin-left: 20px;
}

.bolt-identity-card-persona-text {
  padding: 0 12px;
}

.bolt-identity-contact-card-span-label {
  width: 100px;
}

.bolt-identity-card-styles {
  padding: 0 12px;
}

.bolt-identity-card-text {
  padding-left: 12px;
}

/* Contact card styles */
.bolt-identity-contact-card-header-wrapper {
  padding: 16px 20px 12px 20px;
}

.bolt-identity-contact-card-info-wrapper {
  max-height: 432px;
  padding-left: 20px;
}

.bolt-identity-contact-card-line {
  padding-top: 8px;
  padding-bottom: 8px;
  width: 360px;
}

.bolt-identity-default-card-contact-info-container {
  padding-bottom: 3px;
  padding-top: 3px;
}

.bolt-identity-default-card-contact-line-wrapper {
  padding-bottom: 4px;
  padding-left: 20px;
  padding-right: 20px;
}

.bolt-identity-contact-card-line-top {
  padding-top: 20px;
}

/* Default card styles */
.bolt-identity-default-card-contact-line-label {
  padding-right: 12px;
}

.bolt-identity-default-card-container {
  padding-top: 16px;
}

.bolt-identity-default-card-direct-manager-wrapper {
  padding-top: 4px;
}

.bolt-identity-default-card-direct-manager {
  padding-top: 12px;
}

.bolt-identity-default-card-header-chevron {
  font-size: 0.875rem;
  vertical-align: text-bottom;
}

.bolt-identity-default-card-header-reportsto {
  padding-bottom: 4px;
  padding-left: 20px;
}

.bolt-identity-default-card-header-space {
  padding-right: 12px;
  font-weight: normal;
}

.bolt-identity-default-card-header-wrapper {
  padding-left: 20px;
  padding-right: 20px;
}

.bolt-identity-default-card-info-wrapper {
  padding-top: 16px;
}

.bolt-identity-default-card-simple {
  padding: 20px 0;
}

.bolt-identity-default-card-with-header {
  padding-top: 20px;
}

.bolt-identity-default-card-without-header {
  padding-top: 20px;
}

.bolt-default-card-abridged {
  padding-bottom: 20px;
  padding-top: 20px;
}

/* Organization card styles */
.bolt-identity-organization-card-content {
  max-height: 432px;
}

.bolt-identity-contact-card-organization-card-wrapper {
  max-height: 432px;
  width: 360px;
}

.bolt-identity-organization-card-direct-reports-label {
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 4px;
  padding-top: 20px;
}

.bolt-identity-organization-card-header-wrapper {
  background: rgba( 255, 255, 255 ,  1 );
  background: rgba( var(--palette-neutral-0,255, 255, 255) ,  1 );
  padding: 12px 20px;
}

.bolt-identity-card-unknown-user-content {
  height: 64px;
}

.bolt-identity-card-reports-to-wrapper {
  padding: 3px;
}

/*# sourceMappingURL=IdentityCard.css.map */
`, "",{"version":3,"sources":["webpack://./../azure-devops-ui/src/Components/IdentityCard/IdentityCard.scss","webpack://./../azure-devops-ui/src/_coreStyles.scss","webpack://./../azure-devops-ui/bin/Components/IdentityCard/IdentityCard.css","webpack://./../azure-devops-ui/src/Core/_platformCommon.scss"],"names":[],"mappings":"AAKA,8BAAA;AC0CI;EDxCJ;IAEQ,4BAAA;EELN;AACF;;AFQA;EACI,kBAAA;EACA,YAdQ;AESZ;AC0VI;EHvVJ;IAKQ,gBAjBI;IAkBJ,WAAA;EEJN;AACF;AFMI;EACI,aArBK;AEiBb;;AFQA;EACI,qBAAA;AELJ;;AFQA;EACI,oBG6RS;ADlSb;;AFSA;EACI,sCGbuB;EHgBvB,sEAAA;EACA,2BAAA;EACA,cAAA;EERF,gBAAgB;AAClB;;AAEA;EFSI,mBG+QS;EH9QT,gBAAA;EACA,eAAA;EACA,WAAA;EEPF,4CAA4C;EAC5C,qEAAqE;AFUvE;;AEPA;EFWI,oBAAA;EACA,cAAA;EACA,YAAA;EETF,2BAA2B;EAC3B,gBAAgB;AFWlB;;AERA;EACE,YAAY;AFWd;;AERA;EACE,eAAe;AFWjB;;AERA;EACE,iBAAiB;AFWnB;;AERA;EACE,eAAe;AFWjB;;AERA;EACE,YAAY;AFWd;;AERA;EACE,eAAe;AFWjB;;AERA;EACE,kBAAkB;AFWpB;;AERA,wBFUI;AETJ;EACE,4BAA4B;AFW9B;;AERA;EACE,iBAAiB;EACjB,kBAAkB;AFWpB;;AERA;EFWI,gBAtGQ;EE6FV,mBAAmB;EACnB,YAAY;AFWd;;AERA;EACE,mBAAmB;EACnB,gBAAgB;AFWlB;;AERA;EFWI,mBGmNS;ED5NX,kBAAkB;EAClB,mBAAmB;AFWrB;;AERA;EACE,iBAAiB;AFWnB;;AERA,wBC4Ma;AD3Mb;EACE,mBAAmB;AFWrB;;AERA;EACE,iBAAiB;AFWnB;;AERA;EACE,gBAAgB;AFWlB;;AERA;EACE,iBAAiB;AFWnB;;AERA;EACE,mBAAmB;EACnB,2BAA2B;AFW7B;;AERA;EACE,mBAAmB;EACnB,kBAAkB;AFWpB;;AERA;EACE,mBAAmB;EACnB,mBAAmB;AFWrB;;AERA;EACE,kBAAkB;EAClB,mBAAmB;AFWrB;;AERA;EACE,iBAAiB;AFWnB;;AERA;EACE,eAAe;AFWjB;;AERA;EACE,iBAAiB;AFWnB;;AERA;EACE,iBAAiB;AFWnB;;AERA;EACE,oBAAoB;EACpB,iBAAiB;AFWnB;;AERA,6BFWI;AEVJ;EACE,iBAAiB;AFWnB;;AERA;EACE,iBAAiB;EACjB,YAAY;AFWd;;AERA;EFWI,kBGqHQ;EHpHR,mBGoIS;ED7IX,mBAAmB;EACnB,iBAAiB;AFWnB;;AERA;EACE,sCAAsC;EACtC,+DAA+D;EFWjE,kBAAA;AETA;;AAEA;EFWA,YAAA;AETA;;AAEA;EACE,YAAY;AACd;;AAEA,2CAA2C","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
